import { useState, useEffect } from "react";

export function useCategories(type: string): string[] {
  const [categories, setCategories] = useState<string[]>([]);

  useEffect(() => {
    fetch(`/api/categories?type=${type}`)
      .then((r) => r.json())
      .then((data: { categories?: { id: number; name: string }[] }) => {
        if (data.categories && data.categories.length > 0) {
          setCategories(data.categories.map((c) => c.name));
        }
      })
      .catch(() => {});
  }, [type]);

  return categories;
}
